import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteMenusFromAPI, fetchMenusFromAPI } from "../../../services/MenuMasterService";

export const fetchMenus = createAsyncThunk(
  "menus/fetchMenus",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchMenusFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data menu");
    }
  }
);

export const deleteMenu = createAsyncThunk(
  "menus/deleteMenu",
  async (menu_id, { rejectWithValue }) => {
    try {
      const response = await deleteMenusFromAPI(menu_id);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data menu");
    }
  }
);

const menuMasterSlice = createSlice({
  name: "menuMaster",
  initialState: {
    menus: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    menuSearch: "",
    loading: false,
    error: null,
    totalCount: 0,
    active: 0,
    topLevel: 0,
    withPath: 0,
    keywordSearch: "",
    columnFilters: {}
  },
  reducers: {
    setSearchMenu: (state, action) => {
      state.menuSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetMenuState: (state) => {
      state.menus = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
      state.keywordSearch = '';
      state.columnFilters = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMenus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMenus.fulfilled, (state, action) => {
        const response = action.payload;
        const menus = response.menus;
        state.loading = false;
        state.menus = menus.data || menus;
        state.currentPage = menus.current_page || 1;
        state.lastPage = menus.last_page || 1;
        state.perPage = menus.per_page || 10;
        state.firstItem = menus.from || 1;
        state.totalCount = menus.total || (menus.data ? menus.data.length : menus.length);
        state.active = menus.active ?? 0;
        state.topLevel = menus.topLevel ?? 0;
        state.withPath = menus.withPath ?? 0;
      })
      .addCase(fetchMenus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMenu.fulfilled, (state, action) => {
        state.menus = state.menus.filter(menu => menu.menu_id !== action.payload);
      })
      .addCase(deleteMenu.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchMenu, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetMenuState } = menuMasterSlice.actions;
export default menuMasterSlice.reducer;

